import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class GradeAgeAlignmentService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    // students array format
    search(payload: any): Observable<any> {
        return this.post<any>(EndPoints.gradeAgeAlignment_search, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,
            performancePeriod: payload.performancePeriod,
            grade: payload.grade,
            age: payload.age
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    searchMinified(payload: any): Observable<any> {
        return this.post<any>(EndPoints.gradeAgeAlignment_searchMinified, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,
            performancePeriod: payload.performancePeriod,
            grade: payload.grade,
            age: payload.age
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }
}
